// extracted by mini-css-extract-plugin
module.exports = {"Outer":"Pie_Outer__KuNec","innerText":"Pie_innerText__scLRv","number":"Pie_number__1z3GY","afterDecimal":"Pie_afterDecimal__1F5eN","totalDiv":"Pie_totalDiv__3XC9B"};